import {
  Group,
  isGroup,
  normalizeForDropdown,
  ParentCategory
} from '@insided/deprecated-preact-components/category-selector/CategorySelector'
import { DateFilterFilterSelectorItem } from '@insided/deprecated-control/overview/filters/DateFilterSelector'
import {
  SeparatorSelector,
  TextSelector
} from '@insided/deprecated-control/overview/filters/FiltersMenu'

export const getDateSelectorItems = (): DateFilterFilterSelectorItem[] => {
  return [
    {
      id: 1,
      type: 'relative',
      name: 'Less than',
      value: 'lt',
      unit: 'hour'
    },
    {
      id: 3,
      type: 'relative',
      name: 'More than',
      value: 'gt',
      unit: 'hour'
    },
    {
      id: 4,
      type: 'absolute',
      name: 'Before',
      value: 'before'
    },
    {
      id: 5,
      type: 'absolute',
      name: 'On',
      value: 'on'
    },
    {
      id: 6,
      type: 'absolute',
      name: 'After',
      value: 'after'
    },
    {
      id: 7,
      type: 'range',
      name: 'Custom date range',
      value: 'range'
    }
  ]
}

export const getRangeSelectorItems = () => {
  return [
    {
      id: 1,
      name: 'More than',
      value: 'gt'
    },
    {
      id: 2,
      name: 'Equal to',
      value: 'eq'
    },
    {
      id: 3,
      name: 'Less than',
      value: 'lt'
    }
  ]
}

export const getBooleanSelectorItems = () => {
  return [
    {
      id: 1,
      name: 'Yes',
      value: true
    },
    {
      id: 2,
      name: 'No',
      value: false
    }
  ]
}

export const normalizeCategoriesAndGroups = (categories: Array<ParentCategory | Group>) => {
  return normalizeForDropdown(categories).map((item) => {
    return {
      parentId: item.groupId,
      parentName: item.groupName,
      items: item.categories.map((child, idx) => {
        return {
          id: idx,
          name: child.categoryName,
          value: child.categoryId
        }
      })
    }
  })
}

export const normalizeCategories = (categories: Array<ParentCategory | Group>) => {
  return categories
    .filter((parent) => isGroup(parent) || ('categories' in parent && parent.categories))
    .map((parent) => {
      return {
        parentId: parent.groupId,
        parentName: parent.groupName,
        items: isGroup(parent)
          ? [
              {
                id: parent.groupId,
                name: parent.groupName,
                value: parent.groupId
              }
            ]
          : parent.categories?.map((child, idx) => {
            return {
              id: idx,
              name: child.categoryName,
              value: child.categoryId
            }
          })
      }
    })
}

export const createSeparator = (): SeparatorSelector => ({
  type: 'separator'
})

export const createTextSelector = (
  id: string | number,
  textNode: JSX.Element | string
): TextSelector => ({
  id: `text-selector-${id}`,
  name: textNode,
  type: 'text'
})
